import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "react-query";
import { Put } from "../utils/api";
import { Address } from "../../types/api/Address";

export default (org_id: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<Address, null, Address>(
    async (body: Address) =>
      Put(
        `/api/organization/${org_id}/address`,
        await getAccessTokenSilently(),
        body
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`user`]);
      },
    }
  );
};
